var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Chat = function Chat(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h6.586l2.707 2.707A1 1 0 0 0 22 14V4a2 2 0 0 0-2-2h-9Zm0 2h9v7.586l-1.293-1.293A1 1 0 0 0 18 10h-7V4Z",
      fill: "none",
      className: "tw-fill-current"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M4 9a2 2 0 0 0-2 2v10a1 1 0 0 0 1.707.707L6.414 19H13a2 2 0 0 0 2-2v-2a1 1 0 1 0-2 0v2H6a1 1 0 0 0-.707.293L4 18.586V11h2a1 1 0 1 0 0-2H4Z",
      fill: "none",
      className: "tw-fill-current"
    }))]
  });
};
export default Chat;